import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import MoistureThreshold from '../entities/moisturethreshold'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface MoistureThresholdState extends ListState<MoistureThreshold>{
    editMoistureThreshold:MoistureThreshold
}
class UserMutations extends ListMutations<MoistureThreshold>{

}
class MoistureThresholdModule extends ListModule<MoistureThresholdState,any,MoistureThreshold>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<MoistureThreshold>(),
        filterlist:new Array<MoistureThreshold>(),
        loading:false,
        editMoistureThreshold:new MoistureThreshold()
    }
    actions={
        async getAll(context:ActionContext<MoistureThresholdState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/MoistureThreshold/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<MoistureThreshold>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getPaged(context:ActionContext<MoistureThresholdState,any>,payload:any){
          
            context.state.loading=true;
            //debugger
            let reponse=await Ajax.get('/api/services/app/MoistureThreshold/GetPaged',{params:payload.data});
            
            context.state.loading=false;
            let page=reponse.data.result as PageResult<MoistureThreshold>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getfilter(context:ActionContext<MoistureThresholdState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/MoistureThreshold/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<MoistureThreshold>;
            context.state.totalCount=page.totalCount;
            context.state.filterlist=page.items;
        },
        async create(context:ActionContext<MoistureThresholdState,any>,payload:any){
            await Ajax.post('/api/services/app/MoistureThreshold/Create',payload.data);
        },
        async uploadimg(context:ActionContext<MoistureThresholdState,any>,payload:any){
            //console.log(payload.data.UploadData);
            await Ajax.post('/api/services/app/UploadFile/UploadFile',{params:payload.data.UploadData});
        },
        async update(context:ActionContext<MoistureThresholdState,any>,payload:any){
            await Ajax.put('/api/services/app/MoistureThreshold/Update',payload.data);
        },
        async delete(context:ActionContext<MoistureThresholdState,any>,payload:any){
            await Ajax.delete('/api/services/app/MoistureThreshold/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<MoistureThresholdState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/MoistureThreshold/GetById?Id='+payload.id);
            return reponse.data.result as MoistureThreshold;
        }
    };
    mutations={
        setCurrentPage(state:MoistureThresholdState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:MoistureThresholdState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:MoistureThresholdState,MoistureThreshold:MoistureThreshold){
            
            state.editMoistureThreshold=MoistureThreshold;
            //console.log(state.editFloor);
        }
    }
}
const moisturethresholdModule=new MoistureThresholdModule();
export default moisturethresholdModule;